import { useState } from "react";
import { Share2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

export default function ShareAnswerButton({ messageId, testId, className = "" }) {
  const [busy, setBusy] = useState(false);
  const share = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      const { data } = await api.post("/chat/share", { message_id: messageId });
      const url = `${window.location.origin}/a/${data.token}`;
      const text = "Look what Astra Interactive told me";
      if (navigator.share) await navigator.share({ title: text, text, url });
      else {
        await navigator.clipboard.writeText(url);
        toast.success("Link copied, send it to a friend");
      }
    } catch (err) {
      if (err?.name !== "AbortError" && err?.response?.status !== 403) toast.error("Couldn't share right now");
    }
    setBusy(false);
  };
  return (
    <button data-testid={testId} onClick={share} disabled={busy}
      className={`flex items-center gap-1 text-xs text-[#6c7686] hover:text-[#D4AF37] transition-colors ${className}`}>
      {busy ? <Loader2 size={13} className="animate-spin" /> : <Share2 size={13} />} Share
    </button>
  );
}
